import { AgenturModel } from 'app/models/agentur.model';
import { computed, makeObservable, runInAction } from 'mobx';
import { AgenturStore } from '../agentur.store';
import { SessionStore } from '../session.store';
import { BaseUiStore } from './base.ui.store';
import { AgtAdzEmpfehlungStore, AgtAdzEmpfehlungModel } from '../agt.adzempfehlung.store';
import _ from 'lodash';
const schema = [
	{ path: 'googleProfile', label: 'GUP', color: 'green' },
	{ path: 'socialMediaToolbox', label: 'SM Toolbox', color: 'green' },
	{ path: 'amisNow', label: 'AMIS.NOW', color: 'turquoise' },
	{ path: 'serviceToSale', label: 'STS', color: 'turquoise' },
	{ path: 'akumaPlaner', label: 'AKUMA Planer', color: 'yellow' },
	{ path: 'akumaPrime', label: 'AKUMA Prime', color: 'yellow' },
	{ path: 'meineAllianz', label: 'MAZ', color: 'blue' },
	{ path: 'kvmSupport', label: 'KVM', color: 'blue' },
	{ path: 'leadNow', label: 'LeadNOW', color: 'green' },
];

export class AgtAdzeEmpfehlungVM {
	constructor(item: AgtAdzEmpfehlungModel, agt: AgenturModel) {
		this.agt = agt;
		this.item = item;
	}
	agt: AgenturModel;
	item: AgtAdzEmpfehlungModel;
	@computed
	get agtId() {
		return this.agt.agtId;
	}

	@computed
	get year() {
		return this.item.bm;
	}

	@computed
	get byEmpfehlung() {
		return schema.map((i) => new AgtAdzeEmpfehlungItemVM(this.agt, i, _.get(this.item, i.path, 0)));
	}
}

export class AgtAdzeEmpfehlungItemVM {
	agt: AgenturModel;
	def: any;
	value: number;
	constructor(agt: AgenturModel, def: any, value: number) {
		this.agt = agt;
		this.value = value;
		this.def = def;
	}
}

export class AgtAdzEmpfehlungUiStore extends BaseUiStore<AgtAdzeEmpfehlungVM> {
	name = 'AgtAdzEmpfehlungUiStore';
	session: SessionStore;
	agenturStore: AgenturStore;
	agtAdzEmpfehlungStore: AgtAdzEmpfehlungStore;

	constructor(session: SessionStore, agenturStore: AgenturStore, agtAdzEmpfehlungStore: AgtAdzEmpfehlungStore) {
		super();
		makeObservable(this);
		this.session = session;
		this.agenturStore = agenturStore;
		this.agtAdzEmpfehlungStore = agtAdzEmpfehlungStore;
	}

	onLogout() {
		this.items = [];
	}

	async findByYear(year: number) {
		await this.load();
		return this.items.filter((x) => x.year === year && x.agt.GP!!);
	}

	years = [2025, 2026];
	@computed
	get schema() {
		return schema;
	}

	async findByYearAndAgtId(year: number, agtId: number) {
		await this.load();
		return this.items.find((i) => i.year === year && i.agtId === agtId);
	}

	async _baseLoad() {
		let agtYears = await this.agtAdzEmpfehlungStore.findAll();
		const agts = await this.agenturStore.findAll();
		const res: AgtAdzeEmpfehlungVM[] = [];

		agtYears = agtYears.slice();
		this.years.forEach((year) => {
			let yearItems: AgtAdzEmpfehlungModel[];
			[yearItems, agtYears] = this.filterAndSplice(agtYears, (i: AgtAdzEmpfehlungModel) => i.bm === year);
			agts.forEach((agt) => {
				const item = yearItems.find((i: AgtAdzEmpfehlungModel) => i.agtId === agt.agtId && i.bm === year);
				if (item) {
					res.push(new AgtAdzeEmpfehlungVM(item, agt));
				}
			});
		});

		runInAction(() => {
			this.items = res;
		});
	}
}
